import { Link, useLocation } from "react-router-dom";
import "../styles/Navbar.css"
import ReorderIcon from "@mui/icons-material/Reorder";
import { useEffect, useState } from "react";
import logo from "../assets/img/logo.jpg"
import { useLanguage } from "../helpers/LanguageContext";
import { translations } from "../helpers/translations";

function Navbar() {
    const [expandNavbar, setExpandNavbar] = useState(false)
    const location = useLocation();
    const { language, toggleLanguage } = useLanguage();
    const t = translations[language].navbar;

    useEffect(() => {
        setExpandNavbar(false)
    }, [location]);

    useEffect(() => {
        if (expandNavbar) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [expandNavbar]);

    return (<div className="navbar" id={expandNavbar ? "open" : "close"}>
        <div className="toggle-button">
            <button onClick={() => {
                setExpandNavbar((prev) => !prev)
            }}><ReorderIcon /></button>
        </div>
        <div className="links">
            <img src={logo} className="logo" alt="therelafiocco" />
            <Link to="/" className="click">{t.home}</Link>
            <Link to="/about-me" className="click">{t.about}</Link>
            <Link to="/projects" className="click">{t.projects}</Link>
            <Link to="/experience" className="click">{t.experience}</Link>
        </div>
        <button className="lang-toggle" onClick={toggleLanguage}>
            {language === 'en' ? '🇮🇹' : '🇬🇧'}
        </button>
    </div>)
}

export default Navbar